import { FC } from 'react';
import ProfileIcon from '@/assets/profile.svg';
import { cx } from '@/utils/cx';

export type ProfileCircleProps = {
  className?: string;
  size: 'sm' | 'md' | 'lg';
};

export const ProfileCircle: FC<ProfileCircleProps> = ({ className, size }) => (
  <div
    className={cx(
      'flex items-center justify-center rounded-full bg-gray-500 text-white',
      size === 'sm' && 'size-6 min-w-6',
      size === 'md' && 'size-12 min-w-12',
      size === 'lg' && 'size-16 min-w-16',
      className,
    )}
  >
    <ProfileIcon
      className={cx(size === 'sm' ? 'size-6 min-w-6' : 'size-12 min-w-12')}
    />
  </div>
);
